import { useQuery } from "@tanstack/react-query";
import { auditLogService } from "@/features/audit-logs/services/auditLogService";
import { getAuditActionLabel } from "@/features/audit-logs/constants/action-labels";
import { formatOptionalArabicDateTime } from "@/lib/formatters";
import { queryKeys } from "@/lib/query-keys";

interface ContentAuditTimelineProps {
  pageId: string;
}

export function ContentAuditTimeline({ pageId }: ContentAuditTimelineProps) {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.auditLogs.list({ resource: "page", resourceId: pageId }),
    queryFn: () =>
      auditLogService.list({
        resource: "page",
        resourceId: pageId,
        pageSize: 20,
      }),
  });

  const items = data?.items ?? [];

  if (isLoading) {
    return <p className="text-xs text-muted-foreground">جاري التحميل...</p>;
  }

  if (items.length === 0) {
    return (
      <p className="py-2 text-center text-xs text-muted-foreground">
        لا يوجد سجل إجراءات
      </p>
    );
  }

  return (
    <ol className="max-h-40 space-y-2 overflow-y-auto text-xs">
      {items.map((log) => (
        <li
          key={log.id}
          className="flex items-start justify-between gap-2 border-b border-border pb-2 last:border-0"
        >
          <span className="text-muted-foreground">
            {formatOptionalArabicDateTime(log.createdAt)}
          </span>
          <span className="text-right font-medium">
            {getAuditActionLabel(log.action)}
          </span>
        </li>
      ))}
    </ol>
  );
}
